module.exports = __webpack_public_path__ + "static/img/5-min[cropped].dce8f31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_carousel/compressed/backup/5-min[cropped].jpg
// module id = jP3M
// module chunks = 1